import { createEvent, createStore } from 'effector';

export type SafeAreaInsets = {
  top: number;
  right: number;
  bottom: number;
  left: number;
};

export const ZERO_SAFE_AREA: SafeAreaInsets = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
};

export const updateSafeAreaInsets = createEvent<SafeAreaInsets>();

const sameInsets = (a: SafeAreaInsets, b: SafeAreaInsets): boolean =>
  a.top === b.top && a.right === b.right && a.bottom === b.bottom && a.left === b.left;

// Every viewport event re-reads the insets. A new object for the same values re-applies the
// camera view offset, and that wakes the engine for a full splat frame — keep the old one.
export const $safeAreaInsets = createStore<SafeAreaInsets>(ZERO_SAFE_AREA).on(
  updateSafeAreaInsets,
  (current, next) => (sameInsets(current, next) ? current : next),
);
